import React from "react";
import { useNavigate } from "react-router-dom";
import { IoArrowBackCircle } from "react-icons/io5";
import styled from "styled-components";

function BackArrow() {
  const navigate = useNavigate();

  return (
    <FloatingBack onClick={() => navigate(-1)} aria-label="Go back">
      <IoArrowBackCircle />
    </FloatingBack>
  );
}

const FloatingBack = styled.button`
  position: fixed;
  bottom: 2rem;   /* distance from bottom */
  right: 1.5rem;    /* distance from right */
  border: none;
  cursor: pointer;
  transition: background 0.3s ease;
   border-radius: 50%; 

  &:hover {
    background: #555;   /* hover effect */
    
   }
svg{
   font-size: 4rem;  
   }

`;

export default BackArrow;